import {
  EditContextProvider,
  Form,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../../resource';
import DailyPrizePoolForm from './DailyPrizePoolForm';
import { updateDailyPrizePoolConfig, DailyPrizePoolConfig, PoolType } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const EditDailyPrizePoolConfig = ({
  poolType,
  config,
  onClose,
}: {
  poolType: PoolType;
  config?: DailyPrizePoolConfig;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id: config?.id,
    resource: Resources.redpacket,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify('Update successful', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'Update failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        await updateDailyPrizePoolConfig({
          poolType,
          dailyBudget: data.dailyBudget ? String(data.dailyBudget) : undefined,
          changeReason: data.changeReason || 'Updated via admin panel',
        });
        notify('Update successful', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'Update failed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification defaultValues={config}>
        <DialogTitle>
          Edit {poolType === PoolType.SHARED ? 'Shared' : 'Critical Hit'} Pool Configuration
        </DialogTitle>
        <DialogContent>
          <DailyPrizePoolForm poolType={poolType} config={config} />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="update">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditDailyPrizePoolConfig;
